import {connect} from 'react-redux';
import LeaderboardV2 from '../components/leaderboardV2';
import {setRoundId, fetchLeaderboard, stopEventsPolling} from '../actions/leaderboardV2_index';
import {fullClearEventSlice} from '../actions/event_index';
import {maybeShowRotateHint, markRotateHintUsed} from '../actions/toast_index';
import {selectIsManagerSite} from '../selectors';

const mapStateToProps = (state) => ({
  roundId: state.leaderboardV2.roundId,
  roundList: state.leaderboardV2.roundList,
  isManagerSite: selectIsManagerSite(state),
});

const mapDispatchToProps = (dispatch) => ({
  setRoundId: (roundId) => dispatch(setRoundId(roundId)),
  fetchLeaderboard: (viewMode) => dispatch(fetchLeaderboard(viewMode)),
  clearAll: () => {
    stopEventsPolling();
    dispatch(fullClearEventSlice());
  },
  maybeShowRotateHint: () => dispatch(maybeShowRotateHint()),
  markRotateHintUsed: () => dispatch(markRotateHintUsed()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaderboardV2);
